import {UI, styleRuleCustom, styleRuleInherit, styleRule} from "../../stem-core/src/ui/UI";
import {App} from "../App";
import {GlobalStyleSheet} from "../GlobalStyleSheet";
import {Route, Router} from "../../stem-core/src/ui/Router";
import {iFrameConnection} from "../services/IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "../services/IFrameState";
import {
    IS_PRODUCTION,
    LOGIN_URL,
    LOGIN_WITH_EMAIL_CODE_URL,
    TEST_MODE
} from "../Constants";
import {authService} from "../../client/connection/Services";

import {Theme} from "../../stem-core/src/ui/UI";
import {unwrapArray} from "../../stem-core/src/base/Utils";
import {PageTitleManager} from "../../stem-core/src/base/PageTitleManager";
import {
    ADDRESS_PANEL_URL,
    CTA_URL,
    DONATE_PAGE_URLS,
    FUNCTIONALITY_NOT_ENABLED_URL,
    INLINE_DONATION_URLS,
    INLINE_EDIT_DONATION_URLS,
    INLINE_EDIT_SUBSCRIPTION_URLS,
    INLINE_GIFT_SUBSCRIPTION_URLS,
    INLINE_NEWSLETTER_URLS,
    INLINE_SHOP_URLS,
    INLINE_SUBSCRIPTION_URLS,
    INLINE_USER_DASHBOARD_URLS,
    PAYMENT_DETAILS_PANEL_URL,
    PAYMENT_FAILED_PANEL_URL,
    SUBSCRIPTION_PLAN_PANEL_URL
} from "./PanelConstants";
import {BlinkGlobal, isDeepEqual, isIOS, isIpadOS, isSmallScreen} from "../Utils";

import {Errors} from "../../client/connection/services/Errors";
import {
    GATE_TYPE,
    IFRAME_APP_TYPE,
    PANEL_TYPE,
    POPUP_GATE_TRANSITION_TIME,
    SOCIAL_APPS
} from "../../blink-sdk/Constants";
import {Image} from "../../stem-core/src/ui/UIPrimitives";
import {supportsPassiveEvents} from "../../blink-sdk/utils/Utils";
import {DonateHomePage} from "./donate-page/DonateHomePage";
import {iFrameMerchantService} from "../services/IframeMerchantService";
import {AuthPanelPage} from "./pages/panels/AuthPanelPage.jsx";
import {DonationAuthPage} from "./pages/panels/donation/DonationAuthPage.jsx";
import {EmailCodeConfirmationPanel} from "./pages/panels/EmailCodeConfirmationPanel";
import {DonatePanel} from "./pages/panels/donation/DonatePanel";
import {PaymentMethodPanel} from "./pages/panels/payment-method/PaymentMethodPanel";
import {DonationSuccessPanel} from "./pages/panels/donation/DonationSuccessPanel";
import {EditDonationPanel} from "./pages/panels/donation/edit-donation/EditDonationPanel";
import {CancelDonationPanel} from "./pages/panels/donation/edit-donation/CancelDonationPanel";
import {DonationCanceledPanel} from "./pages/panels/donation/edit-donation/DonationCanceledPanel";
import {EditDonationSuccessPanel} from "./pages/panels/donation/edit-donation/EditDonationSuccessPanel";
import {SubscriptionPlanPanel} from "./pages/panels/subscribe/SubscriptionPlanPanel";
import {SubscribeAuthPage} from "./pages/panels/subscribe/SubscribeAuthPage.jsx";
import {SubscribeReviewOrderPanel} from "./pages/panels/subscribe/SubscribeReviewOrderPanel";
import {SubscribeThankYouPanel} from "./pages/panels/subscribe/SubscribeThankYouPanel";
import {Flow} from "./initializeFlows";
import {EditSubscriptionPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionPanel";
import {EditSubscriptionCancelPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelPanel";
import {EditSubscriptionCancelSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelSuccessPanel";
import {EditSubscriptionSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionSuccessPanel";
import {AutopayThresholdExceededPanel} from "./pages/panels/payment/AutopayThresholdExceededPanel";
import {AutopayDisabledPanel} from "./pages/panels/payment/AutopayDisabledPanel";
import {InsufficientFundsPanel} from "./pages/panels/payment/InsufficientFundsPanel";
import {UnexpectedErrorPanel} from "./pages/panels/payment/UnexpectedErrorPanel";
import {PaymentAndDonationPanel} from "./pages/panels/donation/PaymentAndDonationPanel";
import {addThemeConstants} from "../StyleConstants";
import {CDSAuthPage} from "blinkpay/panel/inline-subscription/auth/CDSAuthPage.jsx";
import {NewsletterSubscribePanel} from "./pages/panels/newsletter/NewsletterSubscribePanel";
import {NewsletterSubscribeSuccessPanel} from "./pages/panels/newsletter/NewsletterSubscribeSuccessPanel";
import {InlineUserDashboard} from "./pages/inline-user-dashboard/InlineUserDashboard";
import {InlineUserDashboardRemoveCardPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveCardPanel";
import {InlineUserDashboardCardInUsagePanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardCardInUsagePanel";
import {InlineUserDashboardChangeEmailCodeConfirmPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardChangeEmailCodeConfirmPanel";
import {AddressPanel} from "./pages/panels/address/AddressPanel";
import {InlineUserDashboardRemoveAddressPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveAddressPanel";
import {InlineUserDashboardAddressInUsePanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardAddressInUsePanel";
import {InlineUserDashboardSubscriptionChangeConfirmPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardSubscriptionChangeConfirmPanel";
import {englishTranslationMap} from "../Messages";
import {apiConnection} from "../../client/connection/BlinkApiConnection";
import {GlobalState} from "../../stem-core/src/state/State";
import {iFrameAuthService, shiftToMerchantToken} from "../services/IFrameAuthService";
import {InlineUserDashboardSubscribeChangeSuccessPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardSubscribeChangeSuccessPanel";
import {FunctionalityNotEnabledPanel} from "./pages/panels/FunctionalityNotEnabledPanel";
import {ensureNaClScript} from "../../client/crypto/encryptJSON";
import {BasePanel} from "./pages/panels/BasePanel";
import {merchantStyleRule} from "./Security";
import {PanelCollapsed} from "./pages/panels/PanelCollapsed";
import {Dispatcher} from "../../stem-core/src/base/Dispatcher";
import {queueMicrotaskWrapper} from "../AsyncAggregateDispatcher";
import {addScrimListeners} from "../widget/WidgetAnimation";
import {PanelCloseButton} from "./PanelCloseButton";
import {GiftSubscriptionPlansPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionPlansPanel";
import {GiftSubscriptionSuccessPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionSuccessPanel";
import {PaymentFailedPanel} from "./pages/panels/payment-method/PaymentFailedPanel";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../blink-sdk/utils/AnalyticsClient";
import {initializeFlows} from "./initializeFlows";
import {ShopPanel} from "./pages/shop/ShopPanel";
import {ShopReviewOrderPanel} from "./pages/shop/ShopReviewOrderPanel.jsx";
import {ShopOrderSuccessPanel} from "./pages/shop/ShopOrderSuccessPanel.jsx";
import {initPanelDebug} from "./PanelDebug";
import {SetupPanelToastSettings} from "../ui/Toast.jsx";


export class PanelAppGlobalStyleSheet extends GlobalStyleSheet {
    @styleRuleCustom({selector: "body"})
    body = {
        margin: 0,
        userSelect: "text",
        height: "100%",
        width: "100%",
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        " *": {
            userSelect: () => isSmallScreen() ? "none" : "auto",
            "-webkit-tap-highlight-color": "transparent",
        },
        position: "absolute",
        overflow: "hidden",
        // These are for Safari border bugs during animations.
        "-webkit-backface-visibility": "hidden",
        "-moz-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-moz-transform": "translate3d(0, 0, 0)",
    };

    @styleRuleInherit
    html = {
        overflow: "hidden !important",
    };

    @styleRuleInherit
    a = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    panelApp = {
        overflow: "hidden !important",
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        background: "transparent",
        height: "100%",
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT,
        ">:first-child": {
            minHeight: "100% !important",
            height: "100% !important",
        }
    };

    @merchantStyleRule
    popupGate = {
        opacity: 1,
        boxSizing: "content-box",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        margin: "auto",
        zIndex: 10500,
        overflow: "hidden",
        transition: POPUP_GATE_TRANSITION_TIME + "ms ease",
        transitionProperty: "width, height, transform",
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        ...iFrameState.gateStyle,
    };

    @merchantStyleRule
    popupGateCustom = {
        ...iFrameState.customGateStyle,
        // Selector for the close button
        ">:first-child>:last-child": {
            ...iFrameState.cancelButtonCustomStyle,
            " g": {
                fill: iFrameState.cancelButtonCustomStyle?.color || "",
            }
        }
    };

    @styleRuleCustom({selector: "b"})
    b = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleInherit
    allInputs = {
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
    };

    @styleRule
    transitionContainer = {
        pointerEvents: "none",
    };
}

export class PanelApp extends App {
    merchantFonts = [];
    sizeStyle = {};

    shouldApplyCustomPanelStyle() {
        return this.activePopupGateCustom;
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        const styleSheet = PanelAppGlobalStyleSheet.getInstance();

        attr.addClass(styleSheet.panelApp);

        if (iFrameState.gateType === GATE_TYPE.popup) {
            attr.addClass(styleSheet.popupGate);
        }
        if (this.shouldApplyCustomPanelStyle()) {
            attr.addClass(styleSheet.popupGateCustom);
        }
        attr.setStyle(this.sizeStyle);
    }

    applyMerchantTheme() {
        this.addMerchantFonts();
        addThemeConstants(iFrameState.theme);
    }

    applyMerchantMessages() {
        for (const [key, value] of Object.entries(iFrameState.messages)) {
            englishTranslationMap.set(key, value);
        }
    }

    applyMerchantConfig() {
        this.applyMerchantTheme(); // TODO is this only limited to the scope of this app? These are Global
        this.applyMerchantMessages();
        Theme.Global.updateStyleSheets();
    }

    constructor(...args) {
        super(...args);

        BlinkGlobal.appInstance = this;
        this.sizeChange = new Dispatcher();
        this.sizeChange.addListener(({height, width}) => {
            this.sizeStyle = {height, width};
            if (this.node) {
                this.setStyle(this.sizeStyle);
            }
        });

        SetupPanelToastSettings();

        const route = iFrameState.gateType === GATE_TYPE.popup ? PANEL_TYPE.empty : CTA_URL;
        this.initRouter(route);

        this.applyMerchantConfig();
    }

    initRouter(initialPage) {
        // The router in this app shouldn't alter the browser history.
        Router.useLocalHistory = true;
        Router.localHistory = ["/" + initialPage];

        let timeout = null;
        let timeoutFunc = null;

        const updateAppStyle = page => {
            if (iFrameState.gateType === GATE_TYPE.popup) {
                const styleSheet = PanelAppGlobalStyleSheet.getInstance();
                if (page instanceof BasePanel) {
                    this.addClass(styleSheet.popupGateCustom);
                } else {
                    this.removeClass(styleSheet.popupGateCustom);
                }
            }
        }

        Router.changeToCustomPanel = function() {
            // The panel rendered will use iFrameState.panelContent. That value has some defaults depending on the
            // panel type (PANEL_CONTENT[panelType]). Look up the "composePanelOptions" method in
            // CreatePanelDefaultOptions.
            Router.changeURL(CTA_URL);
        }

        Router.globalSetURL = function(urlParts) {
            urlParts = unwrapArray(urlParts);
            const page = this.getPageToRender(urlParts);

            if (!page) return;

            this.activePopupGateCustom = page instanceof BasePanel;

            if (timeout && timeoutFunc) {
                clearTimeout(timeout);
                timeoutFunc();
            }

            const activePage = this.getActive();
            const app = BlinkGlobal.appInstance;

            const dispatchRoute = urlParts => {
                if (iFrameState.gateType === GATE_TYPE.popup) {
                    const flowType = iFrameState.panelType;
                    // TODO @Denis Remove this after the TNR branch "blink-setup-event-added" is live.
                    if (iFrameState.panelType === PANEL_TYPE.subscribe) {
                        if (urlParts[0] === ADDRESS_PANEL_URL) {
                            dispatchAnalyticsEvent(AnalyticsEventType.POPUP_PAGE_CHANGE, {page: "subscribeAddress", flowType});
                        } else if (urlParts[0] === PAYMENT_DETAILS_PANEL_URL) {
                            dispatchAnalyticsEvent(AnalyticsEventType.POPUP_PAGE_CHANGE, {page: "subscribePaymentDetails", flowType});
                        }
                    }
                    dispatchAnalyticsEvent(AnalyticsEventType.POPUP_PAGE_CHANGE, {page: urlParts.join("/"), flowType});
                }
                iFrameConnection.sendToSDK(IFrameMessages.ROUTE_CHANGE, {route: urlParts.join("/")});
            };

            if (page instanceof PanelCollapsed) {
                app.setStyle("pointerEvents", "none");
            } else {
                app.setStyle("pointerEvents", "initial");
            }
            if (app.closeButton) {
                app.closeButton.setStyle(app.getCloseButtonStyle("/" + urlParts.join("/")));
            }

            if (activePage !== page) {
                app.applyMerchantConfig(); // Just for good measure. @cleanup it seems to be applied by a later listener.
                if (activePage) {
                    activePage.dispatch("urlExit");
                    if (page instanceof PanelCollapsed) {
                        activePage.applyHiddenStyle(activePage); // I would just redraw but at this point this page might have the controller data cleared already,
                    }
                    page.preRender(app.transitionContainer.node);
                    iFrameConnection.sendToSDK(IFrameMessages.TRANSITION_CHANGE, {transitioning: true});
                    timeoutFunc = () => {
                        page.cancelPreRender();
                        this.setActive(page);
                        dispatchRoute(urlParts);
                        timeout = null;
                        timeoutFunc = null;
                        iFrameConnection.sendToSDK(IFrameMessages.TRANSITION_CHANGE, {transitioning: false});
                    };
                    timeout = this.attachTimeout(timeoutFunc, POPUP_GATE_TRANSITION_TIME);
                } else {
                    queueMicrotaskWrapper(() => {
                        page.preRender(app.transitionContainer.node);
                        page.cancelPreRender();
                        this.setActive(page);
                        page.dispatch("urlEnter");
                        dispatchRoute(urlParts);
                        iFrameConnection.sendToSDK(IFrameMessages.TRANSITION_CHANGE, {transitioning: false});
                    });
                }
            } else {
                page.dispatch("urlReload");
            }

            // When you use blinkaction, this first route gets received in the wallet module when the flow is already
            // active and the actual route is the donation one. It seems like the user exited the flow but it's not
            // the case.

            if (page && page.pageTitle) {
                PageTitleManager.setTitle(page.pageTitle);
            }

            this.dispatch("change", urlParts, page, activePage);
            updateAppStyle(page);
        }
    }

    getCloseButtonStyle(path) {
        return path === "/" + PANEL_TYPE.empty ? {
            opacity: 0,
            pointerEvents: "none",
            cursor: "initial",
        } : {
            opacity: 1,
            pointerEvents: "initial",
            cursor: "pointer",
        };
    }

    addMerchantFonts() {
        const styleElement = document.createElement("style");
        for (const font of iFrameState.fonts) {
            // TODO @cleanup This is stupid
            if (!this.merchantFonts.find(f => isDeepEqual(f, font))) {
                const {family, style, src, weight, unicodeRange} = font;
                styleElement.appendChild(document.createTextNode(`
                @font-face{
                    font-family: ${family};
                    src: ${src};
                    ${style ? `font-style: ${style};` : ""}
                    ${weight ? `font-weight: ${weight};` : ""}
                    ${unicodeRange ? `unicode-range: ${unicodeRange}; ` : ""}
                }`));
                this.merchantFonts.push(font);
            }
        }
        if (styleElement.innerHTML.length) {
            document.head.appendChild(styleElement);
        }
    }

    static initializeGlobalStyle() {
        PanelAppGlobalStyleSheet.initialize();
    }

    static addWsListener(streamName) {
        apiConnection.addWsListener(streamName, async event => {
            if (event.type === "logout") {
                if (iFrameAuthService.merchantToken) {
                    shiftToMerchantToken();
                } else {
                    authService.clearCurrentInfo();
                }
            } else {
                GlobalState.applyEvent(event);
            }
        });
    }

    shouldDisplayCloseButton() {
        return iFrameState.gateType === GATE_TYPE.popup && !!iFrameState.iframeParams.closeButton;
    }

    getContainer() {
        return [
            <div>
                <div ref="transitionContainer" className={PanelAppGlobalStyleSheet.getInstance().transitionContainer}/>
                {this.getRouter()}
                {this.getStaticInvisibleElements()}
                {this.shouldDisplayCloseButton() ? <PanelCloseButton testId={"modalCloseButton"} style={this.getCloseButtonStyle(Router.getCurrentPath())} ref="closeButton"/> : <span/>}
            </div>,
        ];
    }

    // Render these invisible elements so the fetches execute earlier.
    getStaticInvisibleElements() {
        const merchant = iFrameMerchantService.getMerchant();

        // This is so that the elements are under no circumstance visible.
        return (
            <div style={{opacity: "0", pointerEvents: "none", zIndex: -1, position: "absolute", top: -1e4, left: -1e4}}>
                {merchant ? <Image src={merchant.wideLogoUrl}/> : null}
                <div style={{fontStyle: "italic"}}>a</div>
                <div style={{fontWeight: Theme.props.MERCHANT_FONT_WEIGHT_BOLD}}>a</div>
                <div>a</div>
            </div>
        );
    }

    getSubroutes() {
        const getAuthPage = (...args) => {
            if (iFrameState.authSocialProviders.indexOf(SOCIAL_APPS.CDS) !== -1) {
                return new CDSAuthPage(...args);
            }
            if (iFrameState.isInlineDonationFlow()) {
                return new DonationAuthPage(...args);
            }
            if (iFrameState.isInlineSubscriptionFlow()) {
                return new SubscribeAuthPage(...args);
            }

            return new AuthPanelPage(...args);
        };

        const getDonatePage = (...args) => {
            if (Flow.donation.shouldRenderDonatePage()) {
                return new DonatePanel(...args);
            }
            return new PaymentAndDonationPanel(...args);
        };

        const paymentMethodPanelOptions = {
            doNotCache: true,
            beforeEnter: () => {
                if (iFrameMerchantService.isCDSPaymentMethod()) {
                    ensureNaClScript();
                }
            },
        };

        const buildRoute = (route, pageClass, options={doNotCache: true}) =>
            new Route([route], pageClass, [], options);

        return [
            buildRoute(LOGIN_URL, getAuthPage),
            buildRoute(LOGIN_WITH_EMAIL_CODE_URL, EmailCodeConfirmationPanel),
            buildRoute(Errors.errorLinks.INSUFFICIENT_FUNDS, InsufficientFundsPanel),
            buildRoute(Errors.errorLinks.AUTO_PAY_DISABLED, AutopayDisabledPanel),
            buildRoute(Errors.errorLinks.AUTO_PAY_THRESHOLD_EXCEEDED, AutopayThresholdExceededPanel),
            buildRoute(Errors.errorLinks.UNEXPECTED_ERROR, UnexpectedErrorPanel),
            buildRoute(FUNCTIONALITY_NOT_ENABLED_URL, FunctionalityNotEnabledPanel),
            // Note: Never start a flow by only changing a URL. They are strongly correlated with the flow logic that
            // starts and ends in the sdk portion of the code (and the iFrameParams + initializeFlows too).
            buildRoute(CTA_URL, BasePanel),

            buildRoute(PANEL_TYPE.empty, PanelCollapsed),

            buildRoute(INLINE_NEWSLETTER_URLS.subscribe, NewsletterSubscribePanel),
            buildRoute(INLINE_NEWSLETTER_URLS.success, NewsletterSubscribeSuccessPanel),

            buildRoute(INLINE_DONATION_URLS.donate, getDonatePage),
            buildRoute(INLINE_DONATION_URLS.thankYou, DonationSuccessPanel),

            buildRoute(INLINE_EDIT_DONATION_URLS.donate, EditDonationPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.thankYou, EditDonationSuccessPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.cancel, CancelDonationPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.cancelSuccess, DonationCanceledPanel),

            buildRoute(DONATE_PAGE_URLS.home, DonateHomePage),

            buildRoute(INLINE_SUBSCRIPTION_URLS.subscriptionCheckout, SubscribeReviewOrderPanel),
            buildRoute(INLINE_SUBSCRIPTION_URLS.subscribeThankYou, SubscribeThankYouPanel),

            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.subscribe, EditSubscriptionPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancel, EditSubscriptionCancelPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancelSuccess, EditSubscriptionCancelSuccessPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.success, EditSubscriptionSuccessPanel),

            buildRoute(INLINE_USER_DASHBOARD_URLS.home, InlineUserDashboard),
            buildRoute(INLINE_USER_DASHBOARD_URLS.removeCard, InlineUserDashboardRemoveCardPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.cardInUsage, InlineUserDashboardCardInUsagePanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.removeAddress, InlineUserDashboardRemoveAddressPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.addressInUsage, InlineUserDashboardAddressInUsePanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm, InlineUserDashboardSubscriptionChangeConfirmPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess, InlineUserDashboardSubscribeChangeSuccessPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.changeEmailConfirmationCode, InlineUserDashboardChangeEmailCodeConfirmPanel),

            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.giftDetails, GiftSubscriptionPlansPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder, SubscribeReviewOrderPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.success, GiftSubscriptionSuccessPanel),

            buildRoute(INLINE_SHOP_URLS.products, ShopPanel),
            buildRoute(INLINE_SHOP_URLS.reviewOrder, ShopReviewOrderPanel),
            buildRoute(INLINE_SHOP_URLS.orderSuccess, ShopOrderSuccessPanel),

            buildRoute(SUBSCRIPTION_PLAN_PANEL_URL, SubscriptionPlanPanel),
            buildRoute(PAYMENT_FAILED_PANEL_URL, PaymentFailedPanel),
            buildRoute(PAYMENT_DETAILS_PANEL_URL, PaymentMethodPanel, paymentMethodPanelOptions),
            buildRoute(ADDRESS_PANEL_URL, AddressPanel),
        ];
    }

    getRoutes() {
        return new Route([], null, this.getSubroutes(), {});
    }

    preventScrollPropagation() {
        const node = document.documentElement;
        node.setAttribute("tabindex", 0);

        const scrollEventOptions = supportsPassiveEvents() ? {passive: false} : false;

        node.addEventListener("wheel", e => e.stopPropagation(), scrollEventOptions);
        node.addEventListener("touchmove", e => e.stopPropagation(), scrollEventOptions);
    }

    hideScrim() {
        this.redraw();
        Object.assign(document.documentElement.style, {
            background: "transparent",
        });
        if (iFrameState.gateType === GATE_TYPE.popup) {
            iFrameConnection.sendToSDK(IFrameMessages.HIDE_POPUP_SCRIM);
            if (isIOS() || isIpadOS()) {
                document.documentElement.style.removeProperty("-webkit-backdrop-filter");
                document.documentElement.style.removeProperty("backdrop-filter");
            }
        }
    }

    showScrim() {
        if (iFrameState.gateType === GATE_TYPE.popup) {
            iFrameConnection.sendToSDK(IFrameMessages.SHOW_POPUP_SCRIM);
            if (isIOS() || isIpadOS()) {
                Object.assign(document.documentElement.style, {
                    "-webkit-backdrop-filter": "blur(5px)",
                    "backdrop-filter": "blur(5px)"
                });
            }
        }
        Object.assign(document.documentElement.style, {
            background: PanelAppGlobalStyleSheet.getInstance().themeProps.MERCHANT_SCRIM_BACKGROUND,
        });
    }

    onMount() {
        super.onMount();

        initializeFlows();

        addScrimListeners(IFRAME_APP_TYPE.panel);
        this.preventScrollPropagation();

        const checkPaymentRequestError = () => {
            const {paymentRequestStatus, panelType} = iFrameState;
            if (panelType === PANEL_TYPE.payment && authService.isAuthenticated()
                && paymentRequestStatus?.error?.panelLink) {
                Router.changeURL(paymentRequestStatus.error.panelLink);
            }
        };
        checkPaymentRequestError();

        this.attachUpdateListener(iFrameState, () => {
            this.applyMerchantConfig();
            checkPaymentRequestError();
            this.redraw();
        });

        if (iFrameState.gateType === GATE_TYPE.popup && Router.getCurrentPath() !== "/" + PANEL_TYPE.empty) {
            this.showScrim();
        }

        iFrameConnection.addListener(IFrameMessages.ROUTE_CHANGE, ({url}) => {
            if (url) {
                Router.changeURL(url);
            } else {
                // If the page is undefined, it will be handled inside the flow logic.
            }
            // Order matters. We need the router paths to be correct.
            if (url === PANEL_TYPE.empty) {
                this.hideScrim();
            } else if (iFrameState.gateType === GATE_TYPE.popup) {
                this.showScrim();
            }
        });

        if (!IS_PRODUCTION || TEST_MODE) {
            initPanelDebug();
        }
    }
}
